export default "__VITE_ASSET__6OYl39yW__"